var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"raidPage"},[_c('RaidToolbarComp'),_c('router-view',{staticClass:"raidPageRouter"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }